import Geocode from "react-geocode";

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

// set response language. Defaults to english.
Geocode.setLanguage("en");

// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.
Geocode.setRegion("es");

// Enable or disable logs. Its optional.
Geocode.enableDebug();
 
export const getLatLngFromAddress = (address, onSuccess, onError) => {
  if (!address || typeof address !== "string") return;
  Geocode.fromAddress(address).then(
    (response) => {
      const {
        lat,
        lng
      } = response.results[0].geometry.location;
      onSuccess?.(lat, lng);
    },
    (error) => {
      onError?.(error);
    }
  );
};


export const getAddressFromLatLng = (lat, long, onSuccess, onError) => {
  Geocode.fromLatLng(lat, long).then(
    (response) => {
      const address = response.results[0]?.formatted_address || "";
      onSuccess?.(address);
    },
    (error) => {
      onError?.(error);
    }
  );
};

export default Geocode;